import React, { StrictMode } from 'react'
import * as ReactDOMClient from 'react-dom/client'
import App from './App'
import reportWebVitals from './reportWebVitals'
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import './i18n/i18n'
import api from './Services/api'
import {isSelfService} from './Utils/hooks'

const handleErrorEvent = (event) => {
    try {
        const isJqueryError = event?.message?.includes('jQuery is not defined')
        const isGoogleTagManagerError = event?.error?.stack?.includes('googletagmanager')
        const isCrossOriginScriptError = event?.message === 'Script error.' && event?.filename === '' && event?.lineno === 0 && event?.colno === 0

        if (isJqueryError || isGoogleTagManagerError || isCrossOriginScriptError) {
            return;
        }
        api.create().postError({message: event.message, error: event.error, stack: 'error at ' + event.filename + ':' + event.lineno + ':' + event.colno, userAgent: window.navigator?.userAgent}, window.location.href)
    } catch (e) {
        // ignore
    }

    if (isSelfService() && process.env.NODE_ENV === 'production') {
        setTimeout(() => {
            window.location.href = '/self-service/error'
        }, 500)
    }
}

window.addEventListener('error', event => handleErrorEvent(event))

ReactDOMClient.createRoot(document.getElementById('root')).render(
    <StrictMode>
        <App />
    </StrictMode>
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();
